import { Heading, HeadingLevel } from '../../../../../../_helpers/Heading';
import './Header.scss';

export type HeaderProps = {
	titleLvl?: HeadingLevel;
	title?: string;
	description?: string;
	children?: React.ReactNode | React.ReactNode[];
};

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
const Header: React.FC<HeaderProps> = ({ title, description, titleLvl }) => {
	const isVisible = title || description;

	return (
		isVisible && (
			<div className="blk-ac-component-header">
				{!!title && (
					<Heading
						headingLevel={titleLvl}
						className="blk-ac-heading-m-fixed title"
					>
						{title}
					</Heading>
				)}
				{!!description && <p className="description">{description}</p>}
			</div>
		)
	);
};

export default Header;
